<template>
    <div class="pl-4 pr-2">
      <span class="text-subtitle-1">Antall tidsserier: {{ this.timeSeriesCount }} </span>           
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
  name: "FilterResultCounter",
  methods: {
    updateNumberOfTimeSeries(newCount) {
      this.numberOfTimeSeries = newCount;
    }
  },
  computed: {
    ...mapState(["timeSeriesCount"])
  },
  data() {
    return {      
      numberOfTimeSeries: 0
    };
  },
  created() {
    this.$eventHub.$on(
      "timeseries-count-change",
      this.updateNumberOfTimeSeries
    );
  }
};
</script>
<style>

</style>
